module.exports = __webpack_public_path__ + "static/media/SYDummies25-3.1bf0ba03.jpg";